import React from 'react'
import PropTypes from 'prop-types'

import { Asterisk } from 'components/asterisk/Asterisk'

import styles from './Label.module.scss'

export const Label = ({ isRequired = false, children }) => {
  if (isRequired) {
    return (
      <span className={styles.label}>
        {children}
        <Asterisk space />
      </span>
    )
  }

  return children
}

Label.propTypes = {
  isRequired: PropTypes.bool,
  children: PropTypes.node.isRequired,
}
